export const LOCAL_STORAGE_AUTH_ITEM = 'ECW_LOCAL_STORAGE_AUTH';
export const LOCAL_STORAGE_AUTH_URL = 'ECW_LOCAL_STORAGE_AUTH_URL';

export default {
  LOCAL_STORAGE_AUTH_ITEM,
};
